import React from "react";
import AboutTipster from "../components/AboutTipster";
import { ShieldCheck, Zap, Target, Sparkles } from "lucide-react";

const About = () => {
  const values = [
    { icon: ShieldCheck, title: "Transparency", text: "Every pick, win or loss, is published and preserved. No cherry-picking, ever." },
    { icon: Zap, title: "Discipline", text: "Picks are published only when the data supports it — quality of research over quantity." },
    { icon: Target, title: "Precision", text: "Nearly three decades of dropping-odds expertise refined into a repeatable analytical process." },
    { icon: Sparkles, title: "Respect", text: "Members receive picks well in advance so they can shop lines and manage their bankroll." },
  ];
  return (
    <div>
      <div className="bg-ep-royal py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center">
          <div className="text-[#ff5a5a] font-semibold tracking-widest text-xs uppercase">
            About
          </div>
          <h1 className="text-white text-4xl sm:text-5xl lg:text-6xl font-bold mt-3 max-w-3xl mx-auto">
            Serious research for serious football bettors
          </h1>
          <p className="mt-5 text-white/75 max-w-2xl mx-auto leading-relaxed">
            Explorer Picks was founded on a simple belief: consistent long-term
            profitability in football betting is possible only through
            disciplined, evidence-based analysis — not luck, gut feelings, or
            hype. It is a solo operation run by Ryan Fletcher, covering almost
            all leagues where genuine value can be found.
          </p>
        </div>
      </div>

      <AboutTipster />

      <section className="bg-[#f5f7ff] py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="text-center mb-12">
            <div className="text-[#ff5a5a] font-semibold tracking-widest text-xs uppercase">
              Ryan&rsquo;s Values
            </div>
            <h2 className="text-[#0a1a4a] text-3xl sm:text-4xl font-bold mt-3">
              What guides every pick published
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {values.map((v, i) => (
              <div key={i} className="card-lift bg-white rounded-2xl p-6">
                <div className="w-12 h-12 rounded-xl bg-[#ff5a5a]/10 flex items-center justify-center">
                  <v.icon size={22} className="text-[#ff5a5a]" />
                </div>
                <h3 className="mt-4 text-lg font-bold text-[#0a1a4a]">{v.title}</h3>
                <p className="mt-2 text-sm text-[#0a1a4a]/70 leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
